<template>
  <div class="mt-8">
    <px-view-module-header module-name="Cotações" :breadcrumbs="breadcrumbs"/>
    <px-view-header-title class="mt-8" title="Minha resposta">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" link @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header-title>
    <div v-if="loading" class="text-center">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && solicitacao">
      <div>
        <px-resposta-card-cotacao :cotacao="solicitacao.cotacao"/>
      </div>
      <div class="mt-3">
        <px-resposta-cadastro :solicitacao="solicitacao" :moedas="moedas"/>
      </div>
    </div>
  </div>
</template>

<script>
import SolicitacaoService from '@/modules/cotacoes/detalhes/solicitacao-service';
import MoedasService from '@/api/moedas-service';
import { MoedasPadroes } from 'px-business-components';
import RespostaCardCotacao from './RespostaCardCotacao.vue';
import RespostaCadastro from './RespostaCadastro.vue';

export default {
  data() {
    return {
      loading: false,
      solicitacao: null,
      cotacaoId: this.$route.params.id,
      moedas: [MoedasPadroes.BRL],
      breadcrumbs: [
        { text: 'Negócios' },
        { text: 'Cotações' },
      ],
    };
  },
  methods: {
    getMoedas(configuratorId) {
      return MoedasService.getMoedasComprador({ configuratorId })
        .then((response) => {
          this.moedas = [MoedasPadroes.BRL, ...response.data];
        });
    },
    getSolicitacao() {
      this.loading = true;
      return SolicitacaoService.getSolicitacao(this.cotacaoId)
        .then((response) => {
          this.solicitacao = response.data;
          return this.getMoedas(this.solicitacao.cotacao.comprador.id);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickBack() {
      this.$router.go(-1);
    },
  },
  created() {
    this.getSolicitacao();
  },
  components: {
    pxRespostaCardCotacao: RespostaCardCotacao,
    pxRespostaCadastro: RespostaCadastro,
  },
};
</script>
